module.exports = __webpack_public_path__ + "img/refresh-cw-01.c653a90c.svg";